module.exports = __webpack_public_path__ + "static/media/BlockCard.c5ccf705.svg";